/* global axios */

// Aceleres — aba E-mails da Caixa de Entrada.
// Fala com Api::V1::Accounts::Aceleres::EmailInboxController, que tem regra de
// acesso propria: e-mail nao e atendimento e nao passa pelas rotas de conversa.

const accountId = () => {
  if (window.location.pathname.includes('/app/accounts')) {
    return window.location.pathname.split('/')[3];
  }
  return '';
};

const baseUrl = () => `/api/v1/accounts/${accountId()}/aceleres/email_inbox`;

let requestSequence = 0;
const freshParams = (params = {}) => {
  requestSequence += 1;
  return {
    params: { ...params, cache_bust: `${Date.now()}-${requestSequence}` },
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
  };
};

export default {
  inboxes() {
    return axios.get(`${baseUrl()}/inboxes`, freshParams());
  },
  counts() {
    return axios.get(`${baseUrl()}/counts`, freshParams());
  },
  labels() {
    return axios.get(`${baseUrl()}/labels`, freshParams());
  },
  createLabel(title, color) {
    return axios.post(`${baseUrl()}/labels`, { title, color });
  },
  bulkMarkRead(ids) {
    return axios.post(`${baseUrl()}/threads/bulk_read`, { ids });
  },
  bulkMarkUnread(ids) {
    return axios.post(`${baseUrl()}/threads/bulk_unread`, { ids });
  },
  threads({
    page = 1,
    status = 'all',
    folder = 'inbox',
    category = 'primary',
    label = '',
    sort = 'desc',
    q = '',
    inboxId,
  }) {
    return axios.get(
      `${baseUrl()}/threads`,
      freshParams({
        page,
        status,
        folder,
        category,
        label: label || undefined,
        sort,
        q,
        inbox_id: inboxId || undefined,
      })
    );
  },
  compose({
    inboxId,
    to,
    cc,
    bcc,
    subject,
    content,
    draftId,
    emailHtmlContent,
    files = [],
  }) {
    const payload = {
      inbox_id: inboxId,
      to,
      cc,
      bcc,
      subject,
      content,
      draft_id: draftId,
    };
    if (!emailHtmlContent && !files.length)
      return axios.post(`${baseUrl()}/compose`, payload);
    const form = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null) form.append(key, value);
    });
    if (emailHtmlContent) form.append('email_html_content', emailHtmlContent);
    files.forEach(file => form.append('files[]', file));
    return axios.post(`${baseUrl()}/compose`, form);
  },
  saveDraft({ draftId, inboxId, to, cc, bcc, subject, content, files = [] }) {
    const form = new FormData();
    form.append('inbox_id', inboxId);
    form.append('to', to);
    form.append('cc', cc);
    form.append('bcc', bcc);
    form.append('subject', subject);
    form.append('content', content);
    files.forEach(file => form.append('files[]', file));
    const url = draftId
      ? `${baseUrl()}/drafts/${draftId}`
      : `${baseUrl()}/drafts`;
    return draftId ? axios.patch(url, form) : axios.post(url, form);
  },
  deleteDraft(id) {
    return axios.delete(`${baseUrl()}/drafts/${id}`);
  },
  deleteDraftFile(id, fileId) {
    return axios.delete(`${baseUrl()}/drafts/${id}/files/${fileId}`);
  },
  show(id) {
    return axios.get(`${baseUrl()}/threads/${id}`, freshParams());
  },
  markRead(id) {
    return axios.post(`${baseUrl()}/threads/${id}/read`);
  },
  markUnread(id) {
    return axios.post(`${baseUrl()}/threads/${id}/unread`);
  },
  star(id) {
    return axios.post(`${baseUrl()}/threads/${id}/star`);
  },
  snooze(id, until) {
    return axios.post(`${baseUrl()}/threads/${id}/snooze`, { until });
  },
  moveFolder(id, folder) {
    return axios.post(`${baseUrl()}/threads/${id}/folder`, { folder });
  },
  updateLabels(id, labels) {
    return axios.post(`${baseUrl()}/threads/${id}/labels`, { labels });
  },
  reply(id, { content, ccEmails = '', bccEmails = '', files = [] }) {
    const payload = {
      content,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
    };
    if (!files.length)
      return axios.post(`${baseUrl()}/threads/${id}/reply`, payload);
    const form = new FormData();
    Object.entries(payload).forEach(([key, value]) => form.append(key, value));
    files.forEach(file => form.append('files[]', file));
    return axios.post(`${baseUrl()}/threads/${id}/reply`, form);
  },
};
